import React from "react";
import RenderCampaign from "~/components/Campaign/RenderCampaign";

export const CampaignPage = () => {
  return <RenderCampaign />;
};
